module.exports = __webpack_public_path__ + "img/estonia.c0efdb96.svg";